import React from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import { getPages } from '@cotyorg/ccx-organism-cards/helpers/pagination';
import Carousel from '../Carousel';

const getCardsProps = cardsProps => page => ({
  ...cardsProps,
  cardsData: page.map(card => ({
    ...card,
    contentBoxAlignment: 'bottom',
  })),
  key: uuid(),
  fullWidthContent: true,
});

const CardsCarousel = ({
  currentBreakpoint,
  cardsData,
  cards,
  carousel,
  cardsPerPageMap,
}) => (
  <Carousel
    {...carousel}
    isCarouselFullWidth
    isCarouselContentFullWidth
    pagination={{
      isOverlayed: false,
      ...R.prop('pagination')(carousel),
    }}
  >
    {
      getPages({
        currentBreakpoint,
        cardsData,
        getCardsProps: getCardsProps(cards),
        cardsPerPageMap,
      })
    }
  </Carousel>
);

CardsCarousel.propTypes = {
  currentBreakpoint: PropTypes.string.isRequired,
  cardsData: PropTypes.arrayOf(PropTypes.any),
};

export default CardsCarousel;
